import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { loadBizCategory, loadBizCategorySuccess, loadBizCategoryFailure } from './biz-category.action';
import { ApiResponse } from '../../models/common.model';
import { CustomerService } from '../../services/customer.service';

@Injectable()
export class BizCategoryEffects {
  constructor(private actions$: Actions, private http: HttpClient, private customerService: CustomerService) { }

  loadBizCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBizCategory),
      switchMap((action) => {
        return this.customerService.getBizCategories()
          .pipe(
            map((response: ApiResponse) => loadBizCategorySuccess({ bizCategory: response.body })),
            catchError((error) => of(loadBizCategoryFailure({ error })))
          );
      })
    )
  );
}